export const DATADOG_SITE = "us5.datadoghq.com";

export const APPLICATION_ID = "e77f7fa3-7647-466b-a7f8-dba03b84a64e";
export const CLIENT_TOKEN = "pub15e0d3e8d189b1f75c77da30dd139899";
